import {ToastModel} from '@syncfusion/ej2-notifications';

export class ToastWarningModel implements ToastModel {
  readonly cssClass = 'is-warning';
  icon = 'icon-alert-triangle';
  title = '';
  width: 300;

  constructor(public content: string, title?: string, iconCss?: string) {
    if (iconCss) {
      this.icon = iconCss;
    }

    if (title) {
      this.title = title;
    }
  }
}
